// Make sure this file exists and exports the correct URL
const baseURL = process.env.NODE_ENV === 'production'
  ? 'https://mexabeer-3oa6.onrender.com/api/v1'
  : 'http://localhost:7002/api/v1';

export default baseURL;